import { render, staticRenderFns } from "./BankVerification.vue?vue&type=template&id=17560aa2&scoped=true"
import script from "./BankVerification.vue?vue&type=script&lang=js"
export * from "./BankVerification.vue?vue&type=script&lang=js"
import style0 from "./BankVerification.vue?vue&type=style&index=0&id=17560aa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17560aa2",
  null
  
)

export default component.exports